import { useEffect, useState } from "react";
import { Container, Row, Col, Button, Form, Alert, Spinner, Image, Card } from "react-bootstrap";

//import { useSearchParams } from "react-router-dom";

//import { globalDati } from "../../context/globalDati"; //DA CAPIRE DOVE SERVE
import DatiAnagraficiPublic from "./datiAnagraficiPublic";
import TabellaLibera from "./TabellaLibera";

import { dataSigaoToIta } from "apptools/dataConv";
import showFile from "apptools/showfile";
import handleChangeGeneral from "apptools/handleChange";

import { fetchServerBlob } from "apptools/useFetch";

import INFORMATIVA_PRIVACY from "const/informativePrivacy";

export default function PraticaLibera() {
	//let [searchParams] = useSearchParams()
	//const { enti, isNomLoading } = useContext(globalDati)

	// esempio di query http://localhost:3000/libera?sede=torino&ente=010203&title=prova&templateMail=mailLibera&templatePrint=libera&ausili=libera&logo=bologna&informativa=bologna&
	//stato per settare risultato ricerca

	//validazione Form
	const [validated, setValidated] = useState(false);
	const [tipoRichiesta, setTipoRichiesta] = useState(null);

	const [confermata, setConfermata] = useState({
		isLoading: false,
		inviata: false,
		conferma: null,
		message: null,
		error: "",
		buffer: null,
	});

	// modello per pratica nuova

	const newPratica = {
		TIPOPRATICA: null,
		SEDE: import.meta.env.VITE_SEDE,
		DATAPRATICA: new Date().toISOString(),
		NOTE: "",
		MOTIVO: "",
		NOTERICHIESTA: "",
		codici: [],
		ausili: [],
		template: {
			templatePrint: import.meta.env.VITE_TEMPLATEPRINT,
			templateMail: import.meta.env.VITE_TEMPLATEMAIL,
		},
		COGNOME: null,
		NOME: null,
		CODFISC: null,
		SESSO: null,
		NASCITALOCALITA: null,
		NASCITAPROV: null,
		NASCITADATA: null,
		RESIDENZAINDIRIZZO: null,
		RESIDENZALOCALITA: null,
		RESIDENZAPROV: null,
		RESIDENZACAP: null,
		RESIDENZANAZ: null,
		TELEFONO2: null,
		TELEFONO: null,
		CODICEENTE: import.meta.env.VITE_ENTE,
		CODICEDISTRETTO: null,
		EMAIL: null,
		MAILNOTIFICA: null,
		ENTEDESCRIZIONE: null,
		DISTRETTODESCRIZIONE: null,
		DISTRETTOINDIRIZZO: null,
		DISTRETTOTELEFONO: null,
		RESIDENZA: "T",
		RESIDENZAVERAINDIRIZZO: null,
		RESIDENZAVERALOCALITA: null,
		RESIDENZAVERAPROV: null,
		RESIDENZAVERACAP: null,
		PRIVACY: "N",
	};

	const [pratica, setPratica] = useState(newPratica);

	const handleChange = (event) => {
		handleChangeGeneral(event, setPratica);
	};

	const conferma = async (event) => {
		const form = event.currentTarget;
		setValidated(false);
		event.preventDefault();
		event.stopPropagation();

		if (form.checkValidity() === false) {
			alert("modulo errato, ricontrollare campi");
			window.scrollTo(0, 0);
		} else {
			setConfermata({
				isLoading: true,
				inviata: true,
				conferma: null,
				message: null,
				error: "",
			});
			//DA RIVEDERE TEMPLATE STAAMPA

			//RIFARE FETCH SENZA AUTH
			fetchServerBlob("/richiestePublic", "POST", pratica, {
				token: "",
			})
				.then((resp) => {
					setConfermata({
						isLoading: false,
						inviata: true,
						conferma: true,
						message: "La richiesta è stata inviata correttamente",
						error: "",
						buffer: resp,
					});
				})
				.catch((err) => {
					if (err.code === 103) {
						setConfermata({
							isLoading: false,
							inviata: true,
							conferma: true,
							message: err.message,
							error: "",
							buffer: null,
						});
					} else if (err.code === 102) {
						setConfermata({
							isLoading: false,
							inviata: true,
							conferma: false,
							message: err.message,
							error: "",
							buffer: null,
						});
					} else {
						setConfermata({
							isLoading: false,
							inviata: true,
							conferma: false,
							message: err.message,
							error: "",
							buffer: null,
						});
					}
				});
		}
		setValidated(true);
	};

	const stampa = () => {
		let nome =
			"Richiesta del " +
			dataSigaoToIta(pratica.DATAPRATICA) +
			" " +
			pratica.COGNOME +
			" " +
			pratica.NOME;
		//showFile(resp, nome)
		showFile(confermata.buffer, nome, "application/pdf", "pdf");
	};
	function setPraticaHandler(type) {
		setValidated(false);
		setPratica((prevPratica) => {
			return {
				...prevPratica,
				TIPOPRATICA: type,
			};
		});
		setTipoRichiesta(type);
	}
	const tipoPraticaEnv = import.meta.env.VITE_TIPOPRATICA;
	useEffect(() => {
		if (tipoPraticaEnv) {
			setPraticaHandler(tipoPraticaEnv);
		}
	}, []);
	return (
		<Container fluid>
			{!!import.meta.env.VITE_LOGO ? (
				<Row style={{ padding: "1rem 1rem" }}>
					<Col
						xs={6}
						style={{
							textAlign: "center",
						}}
					>
						<Image
							src={"/img/logoLgrMedical.png"}
							style={{
								textAlign: "center",
								width: "15vw",
								height: "auto",
							}}
						/>
					</Col>
					<Col xs={6}>
						<Image
							src={"/img/" + import.meta.env.VITE_LOGO + ".png"}
							style={{
								textAlign: "center",
								width: "40vw",
								height: "auto",
							}}
						/>
					</Col>
				</Row>
			) : (
				""
			)}
			{tipoRichiesta == null ? (
				<>
					<Row>
						<Col>
							<h1 style={{ textAlign: "center", padding: "15px 0px" }}>
								Di cosa hai Bisogno per i tuoi ausili?
							</h1>
						</Col>
					</Row>
					<Row style={{ textAlign: "center", padding: "15px 0px" }}>
						<Col xs={6}>
							<div className="d-grid gap-2">
								<Button
									size="lg"
									style={{
										textAlign: "center",
										fontSize: "1.5rem",
										padding: "1rem 1rem",
									}}
									variant="primary"
									onClick={() => {
										setPraticaHandler("R");
									}}
								>
									Ritiro
								</Button>
							</div>
						</Col>
						<Col xs={6}>
							<div className="d-grid gap-2">
								<Button
									size="lg"
									style={{
										textAlign: "center",
										fontSize: "1.5rem",
										padding: "1rem 1rem",
									}}
									variant="danger"
									onClick={() => {
										setPraticaHandler("I");
									}}
								>
									Manutenzione
								</Button>
							</div>
						</Col>
					</Row>
				</>
			) : (
				<>
					<Row>
						{!tipoPraticaEnv && (
							<Col xs={3} style={{ padding: "1rem 0.5rem" }}>
								<Button
									size="lg"
									variant="primary"
									onClick={() => {
										setConfermata({
											isLoading: false,
											inviata: false,
											conferma: null,
											message: null,
											error: "",
										});
										setPratica(newPratica);
										setTipoRichiesta(null);
									}}
								>
									Torna Indietro
								</Button>
							</Col>
						)}

						<Col>
							<h2 style={{ textAlign: "center", padding: "15px 0px" }}>
								NUOVA RICHIESTA DI{" "}
								{pratica.TIPOPRATICA === "R" ? "RITIRO AUSILI ORTOPEDICI" : "INTERVENTO AUSILI ORTOPEDICI"}{" "}
								- {import.meta.env.VITE_TITLE.replace(/\//gi, "")}
							</h2>
						</Col>
					</Row>

					<hr />

					{!confermata.inviata ? (
						<>
							<Form noValidate validated={validated} onSubmit={conferma} id="pratica">
								<h2 style={{ padding: "10px 0px" }}>DATI ANAGRAFICI:</h2>

								<DatiAnagraficiPublic
									assistito={pratica}
									setAssistito={setPratica}
									sede={import.meta.env.VITE_SEDE}
								/>

								{/* qui dati assisito */}
								<Row>
									{pratica.TIPOPRATICA === "I" ? (
										<>
											<Col>
												<Form.Group className="mb-3">
													<Form.Label>Note Segnalazione (Segnalare la problematica associata)</Form.Label>
													<Form.Control
														type="text"
														maxLength="6000"
														pattern="[0-9a-zA-Z\s!\.,;:?!\/-èòàùìÀÉÙÌ'ÒÈ()+-_é]{0,5950}"
														value={pratica.NOTERICHIESTA}
														required
														onChange={handleChange}
														name="NOTERICHIESTA"
													/>
													<Form.Control.Feedback type="invalid">
														massimo 6000 caratteri solo numeri e lettere
													</Form.Control.Feedback>
												</Form.Group>
												<p>
													<b>
														Per segnalazioni di manutenzioni su più ausili contemporanemante, inserire più
														richieste, una per ogni ausilio
													</b>{" "}
												</p>
											</Col>
										</>
									) : (
										<Col>
											<Form.Group className="mb-3">
												<Form.Label>Motivo Segnalazione (inserire motivo del ritiro)</Form.Label>
												<Form.Control
													as="select"
													name="MOTIVO"
													value={pratica.MOTIVO}
													required
													onChange={handleChange}
												>
													<option value=""></option>
													<option value="Decesso">
														Decesso (indicare la data del decesso nelle note assistito){" "}
													</option>
													<option value="Ingresso in struttura">Ingresso in struttura </option>
													<option value="Cambio residenza">Cambio residenza</option>
													<option value="Non utilizzo">Non utilizzo</option>
													<option value="Altro">Altro</option>
												</Form.Control>
												<Form.Control.Feedback type="invalid">Motivo Obbligatorio</Form.Control.Feedback>
											</Form.Group>
										</Col>
									)}
								</Row>
								<Row>
									<TabellaLibera
										tipo={pratica.TIPOPRATICA}
										codici={pratica.codici}
										setPratica={setPratica}
										sede={import.meta.env.VITE_SEDE}
									/>
								</Row>
								<Row hidden={!!!import.meta.env.VITE_INFORMATIVA}>
									<Col>
										<Card>
											<Card.Header>
												<h3 className="text-center font-weight-bold">INFORMATIVA PRIVACY</h3>
											</Card.Header>
											<Card.Body>
												<div
													dangerouslySetInnerHTML={{
														__html:
															INFORMATIVA_PRIVACY[
																!!import.meta.env.VITE_INFORMATIVA ? import.meta.env.VITE_INFORMATIVA : ""
															],
													}}
												/>
											</Card.Body>
											<Card.Footer>
												<Form.Group>
													{/* <Form.Label> {"\u00A0"}</Form.Label> */}

													<Form.Check
														type="checkbox"
														style={{
															height: "2rem",
															width: "2rem",
															marginRight: "20px",
														}}
														label={"Ho letto l'informativa sul trattamento dei dati e acconsento ".replace(
															/ /gi,
															"\u00A0",
														)}
														name="PRIVACY"
														checked={pratica.PRIVACY === "T" ? true : false}
														onChange={handleChange}
														required={!!import.meta.env.VITE_INFORMATIVA}
													/>
													<Form.Control.Feedback type="invalid">Campo obbligatorio</Form.Control.Feedback>
												</Form.Group>
											</Card.Footer>
										</Card>
									</Col>
								</Row>
								<Row style={{ padding: "15px 0px" }}>
									<Col xs={12}>
										<div className="d-grid gap-2">
											<Button size="lg" variant="success" type="submit">
												Invia Richiesta
											</Button>
										</div>
									</Col>
								</Row>
							</Form>
						</>
					) : (
						""
					)}

					{confermata.isLoading ? (
						<div style={{ textAlign: "center" }}>
							<Spinner style={{ width: "4rem", height: "4rem" }} animation="border" variant="primary" />{" "}
						</div>
					) : (
						""
					)}

					{confermata.inviata && !confermata.isLoading ? (
						<>
							<Row>
								<Col>
									<Alert
										variant={confermata.conferma ? "success" : "danger"}
										style={{
											textAlign: "center",
											fontWeight: "bolder",
											fontSize: "large",
										}}
									>
										{confermata.message}
									</Alert>
									<p> {confermata.error ? confermata.error : ""} </p>
								</Col>
							</Row>
							<Row>
								<Col lg={12} xs={12}>
									<div className="d-grid gap-2">
										<Button variant="info" onClick={stampa} size="lg" hidden={!confermata.conferma}>
											Stampa Ricevuta
										</Button>
									</div>
								</Col>
							</Row>
						</>
					) : (
						""
					)}
				</>
			)}
		</Container>
	);
}
